import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MessageService } from "src/services/message/message.service";
import { AuthService } from "src/services/auth/auth.service";
import { isAndroidNative } from "../../../../services/utils/runtime.utils";

@Component({
  selector: "rc-login-with-socials-buttons",
  templateUrl: "./log-in-with-socials-buttons.component.html",
  styleUrls: ["./log-in-with-socials-buttons.component.scss"],
  standalone: false,
})
export class LogInWithSocialsButtonsComponent {
  @Input() color: "light" | "dark" = "light";
  @Input() actionPrefix: "Continue" | "Register" = "Continue";

  @Output() onSuccess = new EventEmitter<void>();

  constructor(
    protected readonly authService: AuthService,
    protected readonly messageService: MessageService,
  ) {}

  public async loginWithApple(): Promise<void> {
    try {
      await this.authService.loginWithApple(() => this.onSuccess.emit());
    } catch (error) {
      await this.handleLoginErrors(error);
    }
  }

  public async loginWithGoogle(): Promise<void> {
    try {
      await this.authService.loginWithGoogle(() => this.onSuccess.emit());
    } catch (error) {
      await this.handleLoginErrors(error);
    }
  }

  public isAndroid(): boolean {
    return isAndroidNative();
  }

  private async handleLoginErrors(error: any): Promise<void> {
    await this.messageService.presentErrorToast(await AuthService.getErrorMessageToDisplay(error));
  }
}
